<template>
  <div>
    <el-form
      :model="settings"
      :rules="rules"
      ref="form"
      hide-required-asterisk
      label-position="top"
      class="brand-input brand-validation"
      @submit.prevent.native="submit()"
    >
      <div class="px-8 pt-6 pb-6">
        <p class="text-xl font-bold mb-4 text-brand-black">Checkout Page Settings</p>

        <p class="mb-3 text-brand-brown font-medium">
          Enter the URL where you'd like customers to be redirected after updating their payment details:
        </p>
        <el-form-item prop="redirectLink" label="Checkout Redirect Link" class="font-bold text-left pb-2">
          <el-input placeholder="yourdomain.com/account" type="text" v-model="settings.redirectLink">
            <template slot="prepend">https://</template>
          </el-input>
        </el-form-item>

        <div>
          <p class="mb-3 text-brand-brown font-medium">
            Just in case something goes wrong with your primary Checkout Domain, please choose a custom Churnkey subdomain as a fallback.
          </p>
        </div>
        <el-form-item prop="ckSubdomain" label="Fallback Churnkey Subdomain" class="font-bold text-left pb-2">
          <el-input type="text" placeholder="yourcompanyname" v-model="settings.ckSubdomain" :disabled="hasSubdomain">
            <template slot="prepend">https://</template>
            <template slot="append">.churnkey.co</template>
          </el-input>
        </el-form-item>
        <div v-if="hasSubdomain">
          <div class="bg-white border-2 border-brand-yellow text-brand-brown mb-0 p-4 rounded-lg" role="alert">
            <p class="font-bold text-md">Need to modify your Churnkey Subdomain?</p>
            <p class="text-sm font-medium">Contact us and we'll try to update our records within one business day.</p>
          </div>
        </div>
      </div>
      <!-- Cancel / Submit-->
      <div class="bg-brand-light-sand border-t-2 border-brand-sand flex justify-end px-8 py-4 rounded-b-lg">
        <el-button
          @click="
            resetForm();
            close();
          "
          type="plain"
          class="border-brand-gray-blue border-2 px-6 py-2 rounded-lg"
        >
          <span class="text-sm text-brand-blue font-semibold">Nevermind</span>
        </el-button>
        <el-button native-type="submit" type="primary" class="font-bold py-2 px-6 rounded-lg text-sm" :loading="isLoading">Save Settings</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
const rules = {
  redirectLink: [{ required: true, message: 'Redirect Link is required', trigger: 'blur' }],
  ckSubdomain: [{ required: true, message: 'Churnkey Subdomain is required', trigger: 'blur' }],
};
export default {
  data() {
    return {
      isLoading: false,
      settings: {
        redirectLink: '',
        ckSubdomain: '',
      },
      rules,
    };
  },
  props: {
    close: {
      type: Function,
    },
    action: {
      type: Function,
      required: true,
    },
  },
  async created() {
    if (!this.$store.state.org) {
      await this.$store.dispatch('SYNC_USER_RECORD');
    }
    this.settings.customDomain = this.dunning?.checkoutPage?.customDomain || {};
    this.settings.ckSubdomain = this.dunning?.checkoutPage.ckSubdomain || '';
    this.settings.redirectLink = this.dunning?.checkoutPage.redirectLink || '';
  },
  computed: {
    dunning() {
      return this.$store.state.org?.dunning || {};
    },
    checkoutPage() {
      return this.dunning.checkoutPage || {};
    },
    hasSubdomain() {
      return !!this.checkoutPage.ckSubdomain;
    },
    hasRedirectLink() {
      return !!this.checkoutPage.hasRedirectLink;
    },
    hasCustomDomain() {
      return !!this.checkoutPage.customDomain.id;
    },
  },
  methods: {
    resetForm() {
      this.$refs.form.resetFields();
    },
    async submit() {
      if (!this.$refs.form) return;
      await this.$refs.form.validate((valid, fields) => {
        if (valid) {
          this.setCheckoutDomains();
        }
      });
    },
    async setCheckoutDomains() {
      // strip protocol prefix from all strings
      let { ckSubdomain, redirectLink } = this.settings;
      ckSubdomain = ckSubdomain.match(/(^\w+:|^)\/\//) ? ckSubdomain.replace(/(^\w+:|^)\/\//, '') : ckSubdomain;
      redirectLink = redirectLink.match(/(^\w+:|^)\/\//) ? redirectLink.replace(/(^\w+:|^)\/\//, '') : redirectLink;
      try {
        this.isLoading = true;
        await this.action({ ckSubdomain, redirectLink });
        this.isLoading = false;
        this.close();
      } catch (error) {
        this.error = error;
      }
    },
  },
};
</script>
